import React from 'react'


export default function Container1() {
  const handleClickScroll = () => {
    const element = document.getElementById('Container3');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

 


  return (
    <div className='container-fluid cont1   px-0 mx-0'>
      <div className='cont1shade py-5 px-0 mx-0'>
      <div className='container '>
        <div className='row py-3 '>
            <div className=' mx-auto'><h1 className=' py-3 cont1hd'>Werbung genau da,<br/>
wo PKW-Kunden sind</h1>
            <p className='cont1para pb-4'>Unser Werbenetzwerk nutzt digitale Bildschirme in der Region, <br/>
um potenzielle Kunden auf die Angebote von lokalen Unternehmen <br/>
aufmerksam zu machen.</p>
            <a href='https://werbenetzwerk.piiscreen.de/kontakt-formular' className='flinktext text-success1'><button className='btn  btn-white'>Werde Teil vom Netzwerk</button></a><a className='ps-2 text-white contscroll' onClick={handleClickScroll}>Mehr erfahren</a>
            </div>
            
        </div>
        </div>
        </div>
    </div>
  )
}
